'use strict';
import 'whatwg-fetch';
const leftSidebar = {};
import * as formPane from './form-pane';
import lformsUpdater from 'lforms-updater';
import {config} from './config';

const formLists = leftSidebar.formLists={};
formLists.featured = [
  //{text: 'USSG-FHT, (with mock-up items for skip logic demo)', id: '54127-6N'},
  //{text: 'USSG-FHT, (with mock-up items for horizontal layout demo)', id: '54127-6H'},
  {text: 'Personal Health Record', id: 'phr'},
  {text: 'US Surgeon General family health portrait', id: '54127-6'},
  {text: 'Mental RFC assessment form', id: '46611-0'},
  {text: 'Heart ultrasound (echocardiogram)', id: '34552-0'},
  {text: 'Weight & height tracking panel', id: '55418-8'},
  {text: 'Vital signs panel', id: '74728-7'},
  {text: "U.S. standard certificate of death - 2003 revision", id: "69409-1"},
  {text: "Patient-Reported Outcomes with LASIK Symptoms and Satisfaction (PROWL-SS)", id: "prowl-ss"}
];

formLists.geneticFormList = [
  {text: "HL7 Genetic Variant Reporting Panel", id: "81247-9"},
  {text: "HL7 Genetic Variant Reporting Panel (table version)", id: "X2000-0"},
  {text: "ASPA mutation analysis (TRIAL)", id: "46990-8"},
  {text: "Ashkenazi 7 gene targeted mutation analysis (TRIAL)", id: "XXXXX-0"}
];

formLists.bigPanelList = [
  {text: "MDS full assessment form - version 2.0", id: "45981-8"},
  {text: "Minimum Data Set - version 3.0", id: "54580-6"},
  {text: "Outcome and assessment information set (OASIS) form - version C", id: "57039-0"},
  {text: "Continuity assessment record and evaluation tool - Post acute care - discharge", id: "52745-7"},
  {text: "Dialysis adequacy panel", id: "70300-9"}
];

formLists.scorePanelList = [
  {text: "Glasgow Coma Score", id: "35088-4"},
  {text: "FLACC Pain Assessment Panel", id: "38213-5"},
  {text: "Braden scale skin assessment panel", id: "38228-3"},
  {text: "PHQ-9 depression survey", id: "44249-1"},
  {text: "Apgar Panel 10M post birth", id: "48332-1"},
  {text: "Apgar Panel 5M post birth", id: "48333-9"},
  {text: "Apgar Panel 1M post birth", id: "48334-7"},
  {text: "Patient health questionnaire 4 item", id: "69724-3"},
  {text: "Patient health questionnaire 15 item", id: "69728-4"},
  {text: "Morse Fall Scale panel", id: "59453-1"}
];



/**
 *  Initializes the left side bar.
 */
leftSidebar.initSidebar = function() {
  formPane.initFormPane();

  // Adds links for displaying the forms to the sidebar.
  for (let listID in this.formLists) {
    let listContainer = document.getElementById(listID);
    if (listContainer) {
      // First child is the template
      let entryTemplate = listContainer.firstElementChild;
      entryTemplate.remove();
      const entries = formLists[listID];
      entries.forEach(function(entryData, entryIndex) {
        const entryNode = entryTemplate.cloneNode(true);
        entryNode.addEventListener('click', (function() {
          leftSidebar.showFormFromList(listID, entryIndex);
        }).bind(leftSidebar));
        const aTag = entryNode.firstElementChild;
        aTag.setAttribute('id', entryData.id);
        aTag.textContent = entryData.text;
        listContainer.appendChild(entryNode);
      });
    }
  }

  // Initialize search autocompleter

  // Set up the LOINC search autocompleter
  const searchFieldID = 'search-field';
  new LForms.Def.Autocompleter.Search(searchFieldID, config.searchURL,
    {matchListValue: true});
  LForms.Def.Autocompleter.Event.observeListSelections(searchFieldID, (itemData)=>{
    if (itemData.item_code)
      this.codeFromSearchField = itemData.item_code;
  });

  const searchShowButton = document.getElementById('show-button');
  searchShowButton.addEventListener('click', () => {
    if (this.codeFromSearchField)
      this.getDataAndShowForm(this.codeFromSearchField);
  });


  // If there is a formCode parameter in the page, go ahead and show that form.
  if (window.location.search) {
    let formCode;
    // IE 11 does not support URLSearchParams.  Within a year, LForms won't
    // support IE 11 because of its dependency on Angular, so there I think
    // there is no need to support this feature here for IE 11.
    if (URLSearchParams) {
      const params = new URLSearchParams(window.location.search);
      formCode = params.get('formCode');
    }
    if (formCode) {
      this.getDataAndShowForm(formCode);
    }
  }
};


/**
 * Show a form from the selected lists
 * @param listID the id of the list of forms (e.g. "featured")
 * @param formIndex form index in the list
 */
leftSidebar.showFormFromList = function (listID, formIndex) {
  const formData = this.formLists[listID][formIndex];
  var formID = formData.id;
  // show pictures in coding instructions for two forms
  let templateOptions;
  if (formID === 'prowl-ss') {
    templateOptions = {
      allowHTMLInInstructions: true,
      showCodingInstruction: true
    }
  }
  this.selectedForm = { listID, formIndex };
  this.getDataAndShowForm(formID, templateOptions);
};



/**
 * Get the form definition data from lforms-service or server and
 * display a form in the LForms directive
 * @param formID the LOINC number of a selected panel, or an ID for it.
 * @param templateOptions (optional) a hash of LForms "templateOptions" settings for
 * the form.
 */
leftSidebar.getDataAndShowForm = function (formID, templateOptions) {
  // See if there is a local version of the file.
  let dataURL = '/'+formID+'.json';
  var handleResponse = (response=>leftSidebar.showFormFromResponse(response, templateOptions));
  fetch(dataURL).then(handleResponse).catch(function notFound() {
    // Try CTSS
    dataURL = 'https://lforms-service.nlm.nih.gov/loinc_form_definitions?loinc_num='+
      formID;
    fetch(dataURL).then(handleResponse).catch(function error(err) {
      console.log(err);
      formPane.showError("Could not load the form.", err);
    });
  });
};

/**
 *  Handles the response from a request for a form, parses the json, and shows
 *  the form.
 * @param response A Response from a fetch request.
 * @param templateOptions (optional) a hash of LForms "templateOptions" settings for
 * the form.
 */
leftSidebar.showFormFromResponse = function (response, templateOptions) {
  if (!response.ok)
    throw new Error('HTTP response code was '+response.status);
  response.json().then(json => {
    let updatedDef = lformsUpdater.update(json);
    if (templateOptions && json.resourceType) {
      // This is a FHIR definition, but we need to convert to LForms format to
      // set the template options.
      updatedDef = LForms.Util.convertFHIRQuestionnaireToLForms(updatedDef, 'R4');
      updatedDef.templateOptions ||= {};
      Object.assign(updatedDef.templateOptions, templateOptions);
    }
    formPane.showForm(updatedDef);
  }, err => formPane.showError('Unable to parse the loaded form as JSON.', err)
  ).catch(err => formPane.showError('Unable to update the form definition.', err));
};

export const initSidebar = leftSidebar.initSidebar.bind(leftSidebar);
